/**
 * Makes a location table data object from appId
 * @param {string} appId street_streetnum_city
 */
const locationFromAppId = appId => {
    var locationArr = appId.split('_')

    var street = locationArr[0]
    street = street.charAt(0).toUpperCase() + street.slice(1)

    var streetNum = locationArr[1]

    var address = `${street} ${streetNum}`

    var city = locationArr[2]
    city = city.charAt(0).toUpperCase() + city.slice(1)

    var location = {
        app_id: appId,
        city: city,
        address: address
    }

    return location
}

export { locationFromAppId }


// WEBPACK FOOTER //
// ./src/utils.js